module.exports = __webpack_public_path__ + "./docs/img/icon-python.a0090eedb211003e54f48984128930a6.svg";